/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-16 14:18:01
 * @FilePath: /app-monorepo-projects/packages/app-share/src/utils/share.ts
 */
import { ModelMetaFeed, ModelMetaShareInfo } from '@/types/model';
import { getQueryObj, queryStringify } from './no-import-meta/url';
import { IS_SSR } from './env';

export enum EShareInfoType {
  QZONE,
  QQ,
  TIME_LINE,
  WX,
  WB,
  COPY,
  MINI_APP // 新小程序
}
// qq分享里 qzone与qq  wx与朋友圈的index与后台给的是反的
export enum EQQShareInfoType {
  QQ,
  QZONE,
  WX,
  TIME_LINE,
}
export const TEXT = {
  OPEN: '点击右上角通过浏览器打开',
  SHARE: '点击右上角分享给好友',
};

// 精选集分享时替换对应feedid以精确定位
export function replaceFeedId(feed: ModelMetaFeed) {
  const { origin, pathname } = window.location;
  const query = getQueryObj();
  query.id = feed.id;
  const queryString = queryStringify(query) ? `?${queryStringify(query)}` : '';
  return `${origin}${pathname}${queryString}`;
}

export const getWXShareInfo = (feed: ModelMetaFeed, shareInfoType: EShareInfoType) => ({
  title: feed.shareInfo.bodyMap[shareInfoType].title, // 分享标题
  desc: feed.shareInfo.bodyMap[shareInfoType].desc,
  link: replaceFeedId(feed), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl: feed.shareInfo.bodyMap[shareInfoType].image_url, // 分享图标
});

export const getQQShareInfo = (feed: ModelMetaFeed, shareInfoType: EShareInfoType) => ({
  title: feed.shareInfo.bodyMap[shareInfoType].title, // 分享标题
  desc: feed.shareInfo.bodyMap[shareInfoType].desc, // 分享描述
  share_url: replaceFeedId(feed), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  image_url: feed.shareInfo.bodyMap[shareInfoType].image_url, // 分享图标
  back: true,
});

export function setQqShareBtnHandler(callback: Function) {
  if (IS_SSR) return;
  const shareBtns = ['qz', 'qq', 'pyq', 'wx'];
  shareBtns.forEach((item, index) => {
    const shareBtn = document.querySelector(`.icon-share-${item}`);
    if (!shareBtn) return;
    shareBtn.addEventListener('touchstart', () => {
      callback(index);
    });
  });
}

function setWxShareHandler(feed: ModelMetaFeed) {
  if (!window.wx) return;

  window.wx.onMenuShareTimeline(getWXShareInfo(feed, EShareInfoType.TIME_LINE));
  window.wx.onMenuShareAppMessage(getWXShareInfo(feed, EShareInfoType.WX));
  window.wx.onMenuShareQQ(getWXShareInfo(feed, EShareInfoType.QQ));
  window.wx.onMenuShareQZone(getWXShareInfo(feed, EShareInfoType.QZONE));
}

function setQqShareHandler(feed: ModelMetaFeed) {
  if (!window.mqq) return;
  window.mqq.ui?.setOnShareHandler((type: EQQShareInfoType) => {
    if (!window.mqq) return;
    let numType = Number(type);
    switch (numType) {
      case EQQShareInfoType.QQ:
        numType = EShareInfoType.QQ;
        break;
      case EQQShareInfoType.QZONE:
        numType = EShareInfoType.QZONE;
        break;
      case EQQShareInfoType.WX:
        numType = EShareInfoType.WX;
        break;
      case EQQShareInfoType.TIME_LINE:
        numType = EShareInfoType.TIME_LINE;
        break;
    }
    const shareInfo = getQQShareInfo(feed, numType);
    window.mqq.ui?.shareMessage({
      ...shareInfo,
      share_type: type,
    });
  });
}

export function setShareHandler(feed?: ModelMetaFeed) {
  if (!feed) return;
  setWxShareHandler(feed);
  setQqShareHandler(feed);
}

/**
   * 从feed流中的shareInfo解析分享数据
   * @param {Object} svrShareInfo server return info
   */
export function formatFeedShareInfo(svrShareInfo: ModelMetaShareInfo) {
  const shareBody = (svrShareInfo.bodyMap?.[EShareInfoType.QQ]) || {};
  const shareBodyWB = (svrShareInfo.bodyMap?.[EShareInfoType.WB]) || {};
  return {
    title: shareBody.title,
    summary: shareBody.desc || '来微视，发现更有趣的人',
    pic: shareBody.image_url,
    url: svrShareInfo.jumpUrl,
    weibo_title: shareBodyWB.title,
    weibo_summary: shareBodyWB.desc,
    weibo_pic_url: shareBodyWB.image_url,
  };
}

export function changeShareMaskText(text: string) {
  if (IS_SSR) return;
  const domIns = document?.querySelector('#__tx__share__dom__mask .tip');
  if (domIns) domIns.innerHTML = text;
}
